import { Injector, Pipe, PipeTransform } from '@angular/core';
import { FormatterPipeArg } from 'app/component-library/table/pipes/formatter-pipe-arg';
import * as _ from 'lodash';

@Pipe({
  name: 'dynamicPipe',
})
export class DynamicPipe implements PipeTransform {
  public constructor(private injector: Injector) {}

  transform(value: any, pipeToken: any, pipeArgs: any[], rowData?: any): any {
    if (!pipeToken) {
      return value;
    } else {
      const pipe = this.injector.get(pipeToken);
      const newPipeArgs = this.getPipeArgs(pipeArgs, rowData);
      return pipe.transform(value, ...newPipeArgs);
    }
  }

  private getPipeArgs(pipeArgs: any[], rowData?: any): any[] {
    if (!rowData) {
      return pipeArgs;
    }

    return pipeArgs.map((arg: any) => {
      if (arg instanceof FormatterPipeArg) {
        if (arg.isProperty) {
          return _.get(rowData, arg.value, '');
        }

        return arg.value;
      }

      return arg;
    });
  }
}
